export enum WebNotificationType {
    WEB_NOTIFICATION = 'WEB_NOTIFICATION',
    WEB_ACTIVITY = 'WEB_ACTIVITY',
    ALL = 'ALL',
}
